import React from 'react'
import styles from './PlaceRecommends.scss'
import PlaceItem from '@features/food-map/components/PlaceItem'
import { compose, withBeacon, withTranslation } from '@hocs'
import { trackingShareProperty } from '@app-core/beacon/beacon'

function PlaceRecommendCard(props) {
  const { ownPlaceId, data, loc, t, amplitudeEventTrack } = props

  const _onClickedCard = (e) => {
    amplitudeEventTrack('click.recommend.place', trackingShareProperty(data))
  }

  return (
    <div className="recommends__card" onClick={_onClickedCard}>
      <style jsx>{styles}</style>
      <PlaceItem
        item={data}
        isShowOpenHours={false}
        myLat={loc.get('lat')}
        myLng={loc.get('lng')}
        via={ownPlaceId}
        t={t}
      />
    </div>
  )
}

export default compose(withBeacon, withTranslation())(PlaceRecommendCard)
